import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleView } from 'shared/store/features/archiveFilterModalSlice';
import Header from '@liveramp/motif/core/Header';
import { Search } from '@liveramp/motif/icons';
import TextField from '@liveramp/motif/core/TextField';
import BillingTable from './BillingTable';
import styles from './styles.module.scss';
import useBillingDashboardLogic from './useBillingDashboardLogic';
import CampaignStatusModal from './CampaignStatusModal';
import ArchiveFilterModal from './ArchiveFilterModal';
import FilterButton from './FilterButton';
import ArchiveWorkOrderModal from './ArchiveWorkOrderModal';

const BillingDashboard = () => {
  const {
    onFilterTextChange,
    history,
    isCampaignStatusFilterModalOpened,
    setIsCampaignStatusFilterModalOpened,
    campaignStatusFilter,
    setCampaignStatusFilter,
    getStatusSelectLabel,
    archiveFilterStatus,
    isArchiveFilterModalOpened
  } = useBillingDashboardLogic();
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <Header
          class={styles.header}
          onClickBackArrow={() => history.goBack()}
        >
          <p className={styles.tableHeader}>Work Order Management</p>
        </Header>
        <div className={styles.tableControlsContainer}>
          <TextField
            className={styles.filterByTextInput}
            id="outlined-end-icon-adornment"
            placeholder="Search by work order name or ID"
            InputProps={{
              startAdornment: <Search>thing</Search>
            }}
            onChange={onFilterTextChange}
          />
          <FilterButton
            onClick={() => dispatch(toggleView({ isArchiveFilterModalOpened: true }))}
            label={`Showing: ${archiveFilterStatus}`}
            isFilterComponentOpened={isArchiveFilterModalOpened}
            FilterComponent={(props: {buttonBoundingRect: ClientRect | null}) => (
              <ArchiveFilterModal
                archiveStatusButtonBoundingRect={props.buttonBoundingRect}
              />
            )}
          />
          <FilterButton
            onClick={() => setIsCampaignStatusFilterModalOpened(true)}
            label={getStatusSelectLabel(campaignStatusFilter)}
            isFilterComponentOpened={isCampaignStatusFilterModalOpened}
            variant={`${campaignStatusFilter.length ? 'primary' : 'outlined'}`}
            color={`${campaignStatusFilter.length ? 'primary' : 'secondary'}`}
            FilterComponent={(props: {buttonBoundingRect: ClientRect | null}) => (
              <CampaignStatusModal
                isDialogOpened={isCampaignStatusFilterModalOpened}
                onCloseDialog={() => setIsCampaignStatusFilterModalOpened(false)}
                setCampaignStatusFilter={setCampaignStatusFilter}
                campaignStatusFilter={campaignStatusFilter}
                boundingCampaignButtonRect={props.buttonBoundingRect}
              />
            )}
          />
        </div>
        <BillingTable />
        <ArchiveWorkOrderModal />
      </div>
    </div>
  );
};

export default BillingDashboard;
